import { styled, css } from 'styled-components'
import { onMediumScreen, onLargeScreen } from 'mixtiles-web-common'

export const Container = styled.div<{
  $noPadding: boolean
}>`
  display: flex;
  flex-direction: column;

  ${onMediumScreen()} {
    margin-bottom: 50px;
    transition: margin-bottom 0.2s;

    ${({ $noPadding }) =>
      $noPadding &&
      css`
        margin-bottom: 0;
      `}
  }
`

export const ExtraFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`

export const PhoneNumberDisclaimer = styled.div`
  padding-top: 8px;
  font-size: 14px;
  opacity: 0.7;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.secondaryDark};
  letter-spacing: -0.1px;
  white-space: pre-line;
  ${onLargeScreen()} {
    white-space: normal;
  }
`

export const EmailConsentContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
`

export const SmsConsentContainer = styled.div`
  margin: 28px 0 14px;
  display: flex;
  align-items: center;
`

export const ConsentText = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.secondaryDark};
  letter-spacing: -0.1px;
  margin-left: 10px;
`
